import {Chart} from 'chart.js';

export default class PieChart {
    private chart: Chart;

    public constructor(
        element: HTMLCanvasElement,
        dataset: PieChartDataSet,
        labels: string[],
    ) {
        this.chart = new Chart(
            element,
            {
                type: 'pie',
                data: {
                    datasets: [dataset],
                    labels,
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: true,
                    plugins: {
                        legend: {
                            display: false,
                        },
                    },
                },
            },
        );
    }
}

export interface PieChartDataSet {
    data: number[];
    backgroundColor: string;
}
